import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  TextField,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ChevronLeft } from "react-feather";
import { useTheme } from "@mui/system";
import Attivita from "../tabs/dettagli/Attivita";
import Condizioni from "../tabs/dettagli/Condizioni";
import Documenti from "../tabs/dettagli/Documenti";
import Dettagli from "./Dettagli";
import Precontrattuale from "../tabs/dettagli/Precontrattuale";
import Generali from "../tabs/dettagli/Generali";
import { TabsWrapper } from "../style";
import { API_BASE_URL } from "../../../../config";
import { useNavigate } from "react-router-dom";
import { useFormRCAutoDetails } from "../rcautoContext";
import Sinistri from "../tabs/dettagli/Sinistri";
import { DateTimePicker } from "@mui/x-date-pickers";
import { showSnackbar } from "../../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const VaiAiDettagli = ({ setVaiSection, dataset }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const item = dataset[0];
  const navigate = useNavigate();
  const { dispatch: dispatchForm } = useFormRCAutoDetails();
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState("");
  const [note, setNote] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [activeButton, setActiveButton] = useState(null);
  const [dateError, setDateError] = useState(false);
  const [utenteSelezionato, setUtenteSelezionato] = useState(null);
  const [utenteSelezionatoError, setUtenteSelezionatoError] = useState(false);
  const [errors, setErrors] = useState({
    date: false,
    utenteSelezionato: false,
  });

  console.log(selectedDate);
  const dispatch = useDispatch();

  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message, severity }));
  };

  const handleButtonClick = (button) => {
    setActiveButton(button);
    setNote("");
    const defaultDate = new Date();
    defaultDate.setHours(23, 59, 0, 0);
    setSelectedDate(button.fDt === 1 ? defaultDate : null);
    setDateError(false);

    if (button.fUt && button.fUt.length > 0) {
      setUtenteSelezionato(button.fUt[0].idUID);
    } else {
      setUtenteSelezionato(null);
    }
    setUtenteSelezionatoError(false);

    if (button.MessageStep) {
      setDialogContent(button.MessageStep);
      setOpenDialog(true);
    } else {
      // Execute immediate action if needed
      console.log("Execute action for button:", button.lN);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setActiveButton(null);
    setDateError(false);
    setUtenteSelezionato(null);
    setUtenteSelezionatoError(false);
    setNote("");
    setSelectedDate(null);
  };

  const fetchMessages = async () => {
    const token = sessionStorage.getItem("token");
    if (!item?.idUID || !token) return;

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUIDRequest: item.idUID,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/requestGetMessage`,
        requestOptions,
      );
      const res = await response.json();

      if (res.status === -1) {
        sessionStorage.clear();
        window.location.href = "/auth/sign-in";
        return;
      }

      if (res.status === 0) {
        console.log(res.message);
        return;
      }

      if (res.data) {
        dispatchForm({ type: "UPDATE_MESSAGGI", payload: res.data });
      }
    } catch (e) {
      console.log("Error fetching messages:", e);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [item?.idUID]);

  async function richiesteGetDetails() {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idUIDRequest: item?.idUID,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/requestGetDetails`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
        return;
      }
      if (responseData.status === 0) {
        navigate("/private");
        handleSnackbar(responseData.message, "error");
        return;
      }
      return responseData.data;
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    richiesteGetDetails()
      .then((data) => {
        setData(data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleClickConferm = async () => {
    if (activeButton?.fDt === 1 && !selectedDate) {
      setDateError(true);
      return;
    }

    const formattedDate = selectedDate
      ? {
          date: `${String(selectedDate.getDate()).padStart(2, "0")}/${String(
            selectedDate.getMonth() + 1,
          ).padStart(2, "0")}/${selectedDate.getFullYear()}`,
          time: `${String(selectedDate.getHours()).padStart(2, "0")}:${String(
            selectedDate.getMinutes(),
          ).padStart(2, "0")}`,
        }
      : {};

    console.log("Azione confermata:", {
      idex: activeButton.idex,
      fdate: formattedDate.date ? formattedDate.date : "",
      ftime: formattedDate.time ? formattedDate.time : "",
      note,
      /* ...formattedDate, */
      utenteSelezionato: utenteSelezionato ? utenteSelezionato : 0,
      idUIDRequest: item?.idUID,
    });

    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          idex: activeButton.idex,
          fdate: formattedDate.date ? formattedDate.date : "",
          ftime: formattedDate.time ? formattedDate.time : "",
          note,
          /* ...formattedDate, */
          utenteSelezionato: utenteSelezionato ? utenteSelezionato : 0,
          idUIDRequest: item?.idUID,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/requestUpdateStatus`,
        requestOptions,
      );
      const responseData = await response.json();

      if (responseData.status === -1) {
        navigate("/auth/sign-in");
        return;
      }
      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        setLoading(true);
        richiesteGetDetails()
          .then((data) => {
            setData(data);
          })
          .finally(() => {
            setLoading(false);
          });
      }
      handleCloseDialog();
    } catch (error) {
      return error;
    }
  };

  return (
    <>
      {loading ? (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            height: "1000px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box sx={{ width: "100%" }}>
          <Box display="flex" justifyContent="space-between" alignItems="start">
            <Button onClick={() => setVaiSection(false)}>
              <ChevronLeft />
              <FormLabel>Indietro</FormLabel>
            </Button>
            <Box mb={4}>
              <Chip
                sx={{
                  border: `1px solid #${data?.richiesta[0]?.sCol}`,
                  backgroundColor: "transparent",
                  color: /* item?.sCol === "336699" ? "white" : "black", */ `#${data?.richiesta[0]?.sCol}`,
                  fontSize: 14,
                  fontWeight: "bold",
                  width: "100%",
                  height: "2rem",
                }}
                label={data?.richiesta[0]?.sDesc}
              />
            </Box>
          </Box>
          {/* {dataset[0]?.idUID} */}
          <Box
            display="flex"
            flexDirection={isMobile ? "column-reverse" : "row"}
            justifyContent="space-between"
            gap={4}
          >
            <Box width={isMobile ? "100%" : "50%"}>
              <TabsWrapper>
                <Tabs
                  value={activeTab}
                  onChange={(_, newValue) => setActiveTab(newValue)}
                  sx={{
                    width: "100%",
                    mt: 2,
                    mb: 4,
                    backgroundColor:
                      theme.palette.mode === "light" ? "#fff" : "#233044",
                  }}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                >
                  <Tab label="Generali" />
                  <Tab label="Attività" />
                  <Tab label="Documenti" />
                  <Tab label="Precontrattuale" />
                  <Tab label="Condizioni" />
                  <Tab label="Sinistri" />
                </Tabs>
                <CustomTabPanel value={activeTab} index={0}>
                  <Generali item={data?.richiesta[0]} />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={1}>
                  <Attivita idUID={item?.idUID} fetchMessages={fetchMessages} />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={2}>
                  <Documenti idUidRequest={item?.idUID} />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={3}>
                  <Precontrattuale data={data?.richiesta[0]} />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={4}>
                  <Condizioni />
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={5}>
                  <Sinistri data={data?.richiesta[0]} />
                </CustomTabPanel>
              </TabsWrapper>
            </Box>
            <Box width={isMobile ? "100%" : "50%"} mt={2}>
              {Object.keys(data.bt).length !== 0 && (
                <Box display="flex" gap={4} mb={5}>
                  {Array.isArray(data?.bt) &&
                    data.bt.map((button) => (
                      <Button
                        key={button.idex}
                        sx={{
                          backgroundColor: `#${button?.btColor}`,
                          height: "36px",
                          "&:hover": {
                            backgroundColor: `#${button?.btColor}`,
                            filter: "brightness(0.9)",
                          },
                        }}
                        variant="contained"
                        onClick={() => handleButtonClick(button)}
                      >
                        {button.lN}
                      </Button>
                    ))}
                </Box>
              )}
              <Dettagli idUID={data?.richiesta[0]?.idUID} type="RCA" />
              {/* <Dettagli type="RCA" dataPreventivo={data?.richiesta[0]} /> */}
            </Box>
          </Box>
          <Dialog open={openDialog} onClose={handleCloseDialog}>
            <DialogTitle>Conferma Azione</DialogTitle>
            <DialogContent>
              <div dangerouslySetInnerHTML={{ __html: dialogContent }} />
              <Box mt={4} display="flex" flexDirection="column" gap={2}>
                {activeButton?.fNt === 1 && (
                  <TextField
                    label="Note"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                )}

                {activeButton?.fDt === 1 && (
                  <DateTimePicker
                    label="Data e ora"
                    value={selectedDate}
                    onChange={(newValue) => {
                      setSelectedDate(newValue);
                      if (newValue) setDateError(false);
                    }}
                    ampm={false}
                    inputFormat="dd/MM/yyyy HH:mm"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        error={dateError}
                        helperText={dateError ? "Campo obbligatorio" : ""}
                        required
                      />
                    )}
                  />
                )}
                {activeButton?.fUt.length !== 0 && (
                  <FormControl size="small" margin="none">
                    <InputLabel id="tipologia-label">Utenti</InputLabel>
                    <Select
                      labelId="tipologia-label"
                      id="tipologia"
                      name="tipologia"
                      label="Utenti"
                      error={utenteSelezionatoError}
                      helperText={
                        utenteSelezionatoError ? "Campo obbligatorio" : ""
                      }
                      required
                      options={activeButton?.fUt}
                      value={utenteSelezionato}
                      MenuProps={MenuProps}
                      onChange={(e) => setUtenteSelezionato(e.target.value)}
                    >
                      {activeButton?.fUt.map((option) => (
                        <MenuItem key={option.idUID} value={option.idUID}>
                          {option.cognome} {option.nome} ({option.azienda})
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDialog}>Annulla</Button>
              <Button
                onClick={handleClickConferm}
                variant="contained"
                autoFocus
              >
                Conferma
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      )}
    </>
  );
};

export default VaiAiDettagli;
